import type { JSX } from "preact";

type PanelProps = {
  raised?: boolean;
  pad?: boolean;
} & JSX.HTMLAttributes<HTMLDivElement>;

export function Panel({ raised, pad = true, class: className, children, ...rest }: PanelProps) {
  const cls = ["panel", raised && "panel-raised", pad && "panel-pad", className as string]
    .filter(Boolean)
    .join(" ");
  return (
    <div class={cls} {...rest}>
      {children}
    </div>
  );
}
